/** Component page that displays the login details for the user to login to the demo site.
 */
import React from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import StageManager from '../../services/stageManager';
import Header from '../header/Header';
import ClipBoard from '../components/ClipBoard';

export default class DemoSite extends React.Component {
    constructor() {
        super();
        this.stageMan = new StageManager();
        this.state = {
            username: 'testusername@m365x123456.onmicrosoft.com',
            password: 'testpassword',
            demourl: 'https://m365x123456.sharepoint.com/'
        };
    }

    render() {
        let stageObj = this.stageMan.getStageByIndex(this.props.location.state.stage);
        let descText = stageObj[this.props.location.state.type].desc;
        return (
            <div>
                <Header history={this.props.history} />
                <div className={"pageContainer"}>
                <br />
                    <Card>
                        <Card.Body>
                            <Card.Title>Demo Site Details</Card.Title>
                            <Card.Text>
                                <Form.Group>
                                {descText}
                                    <Form.Row>
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control readOnly={true} id={"demousername"} type='input' value={this.state.username} />
                                        <ClipBoard data={this.state.username} />
                                        {/* <div onClick={() => { this._copyToClipboard('demousername') }}>Copy Username to clipboard</div> */}
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control readOnly={true} type='input' id={"demopassword"} value={this.state.password} />
                                        <ClipBoard data={this.state.password} />
                                        {/*<div onClick={() => { this._copyToClipboard('demopassword') }}>Copy Password to clipboard</div>*/}
                                    </Form.Row>
                                </Form.Group>
                                <Button href={this.state.demourl} target={"_blank"}>Go To Site</Button>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/DemoSite.js